<template>
  <PopupUI
    v-if="isOpen"
    :small="true"
    class="phone-verification-call"
    @on-close="hide"
  >
    <template slot="header">
      <h3 class="subtitle-h3 txt-blue-common txt-center no-margin">
        Подтвердите номер телефона
      </h3>
    </template>

    <template>
      <div class="txt-center txt-secondary-on-wite txt-s">
        На&nbsp;ваш номер <nobr>{{ phoneFormatted }}</nobr> позвонит
        наш робот и&nbsp;продиктует код.
        Введите его в&nbsp;поле ниже
      </div>

      <CodeEntryFormUI
        :init-send-code="true"
        :function-for-resend-code="functionForResendCode"
        :show-loader="showLoader"
        :server-errors="serverErrors"
        btn-title="Позвонить ещё раз"
        class="phone-verification-call__form"
        @send-code="updateCode"
        @send-new-code="serverErrors = null"
      />
    </template>
  </PopupUI>
</template>

<script>
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';
import { mainApi } from '../../../api';
import { getServerErrors } from '../../../utils/validate';
import PopupUI from '../common/PopupUI.vue';
import CodeEntryFormUI from '../common/CodeEntryFormUI/index.vue';

export default {
  name: 'CallPhoneNumberVerificationRoot',

  components: {
    CodeEntryFormUI,
    PopupUI
  },

  data() {
    return {
      isOpen      : null,
      phoneNumber : null,

      action       : null,
      showLoader   : false,
      serverErrors : null
    };
  },

  watch: {
    isOpen(value) {
      if (!value) {
        enableBodyScroll(this.$el);
      } else {
        disableBodyScroll(this.$el);
      }
    }
  },

  computed: {
    phoneFormatted() {
      const p = this.phoneNumber;
      const formattedNumber = `${p.slice(1, 4)} ${p.slice(4, 7)}-${p.slice(7, 9)}-${p.slice(9, 11)}`

      return `+7 ${ formattedNumber }`;
    }
  },

  created() {
    document.addEventListener('verification:hide', () => this.hide());
    document.addEventListener('verification:show', (event) => this.show(event));
  },

  methods: {
    hide() {
      this.isOpen = false;
    },

    show(event) {
      const phoneNumber = event.detail && event.detail.phoneNumber
        ? event.detail.phoneNumber
        : false;

      if (!phoneNumber) {
        return;
      }

      this.phoneNumber = phoneNumber;
      this.action = event.detail && event.detail.action
        ? event.detail.action
        : null;

      this.isOpen = true;
    },

    // Повторная отправка смс
    async functionForResendCode(recaptchaToken) {
      try {
        const params = {
          phone          : this.phoneNumber,
          _captcha_token : recaptchaToken
        };

        if (this.action) {
          params.action = this.action;
        }

        await mainApi.modules.common.phoneVerificationCall(params);
      } catch {}
    },

    // Метод подтверждения правильности введённого кода
    async updateCode(value) {
      try {
        this.serverErrors = null;
        this.showLoader = true;

        const dataForm = new FormData();
        dataForm.append('code', value);
        if (this.action) {
          dataForm.append('action', this.action);
        }

        const response = await mainApi.modules.common.validatePhoneVerificationCall(dataForm);
        if (response) {
          this.$root.$data.successVerificationCallback(response.auth_token ? response.auth_token : null);
          this.hide();
        }
      } catch (err) {
        const serverErrors = getServerErrors(err);
        this.serverErrors = serverErrors && serverErrors.errors ? serverErrors.errors : null;
      } finally {
        this.showLoader = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.phone-verification-call {
  &__form {
    margin-top: 16px;

    @media (min-width: 1024px) {
      margin-top: 24px;
    }
  }
}
</style>
